import React from "react";
import { useNavigate } from "react-router-dom";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import LoginScreen from "../../Views/Account/Login";
import Snackbar from "../../Components/Snackbar";
import Progressbar from "../../Components/Progressbar";

function Login(props) {
  const navigate = useNavigate(); // Route move api
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [progress, setProgressbar] = React.useState(false);
  const [inputs, setInputs] = React.useState({
    userId: "",
    userPw: "",
    lang: "kr",
  });
  const combos = [
    { value: "en", name: "English" },
    { value: "kr", name: "한국어" },
    { value: "vn", name: "Việt Nam" },
    { value: "ch", name: "中國" },
  ];
  const [screenWidth, setScreenWidth] = React.useState(
    Commons.Dimentions().width
  );
  React.useEffect(() => {
    const HandleResize = () => {
      setScreenWidth(Commons.Dimentions().width);
    };
    window.addEventListener("resize", HandleResize);

    return () => window.removeEventListener("resize", HandleResize);
  }, []);

  const LoginLogic = async () => {
    if (screenWidth < 400) {
      setProgressbar(true);
    } else {
      Dialog.ProgressBar(true);
    }
    console.log(screenWidth);
    let lans = [];
    let menus = [];
    let auths = [];
    let token = [];
    try {
      await IndexedDb.ClearDb("LanguageList");
      await IndexedDb.ClearDb("MenuList");
      await IndexedDb.ClearDb("AuthList");
      // await IndexedDb.ClearDb("LoginInfo");
      token = await IndexedDb.GetAllDb("LoginInfo");
      if (token.length > 0) {
        if (new Date(token[0].expiredTime) < new Date()) {
          await IndexedDb.ClearDb("LoginInfo");
        }
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.login,
        {
          userId: inputs.userId,
          password: inputs.userPw,
          lanCode: inputs.lang,
          token: token.length == 0 ? "string" : token[0].token,
        }
      ).then(async (result) => {
        let data = result.data;

        for (let i = 0; i < data.languageList.length; i++) {
          lans.push(data.languageList[i]);
        }
        for (let i = 0; i < data.menuList.length; i++) {
          // if (data.menuList[i].mcategoCd === "MM10060") {
          // 	menus.push({
          // 		...data.menuList[i],
          // 		mobile: "Y",
          // 	});
          // } else {
          // 	menus.push(data.menuList[i]);

          // }
          menus.push(data.menuList[i]);
        }
        for (let i = 0; i < data.authList.length; i++) {
          auths.push(data.authList[i]);
        }
        // if (token[0].token != data.userInfo.token) {
        await IndexedDb.ClearDb("LoginInfo");
        await IndexedDb.AddDb("LoginInfo", [
          {
            token: data.userInfo.token,
            userId: data.userInfo.userId,
            userNm: data.userInfo.userNm,
            validaty: data.userInfo.validaty,
            refreshToken: data.userInfo.refreshToken,
            id: data.userInfo.id,
            guidId: data.userInfo.guidId,
            expiredTime: data.userInfo.expiredTime,
            connTime: Commons.DateFormating(new Date(), 1),
            plantList: data.plantList,
            lang: inputs.lang,
          },
        ]);
        // }
        await IndexedDb.AddDb("LanguageList", lans);
        await IndexedDb.AddDb("MenuList", menus);
        await IndexedDb.AddDb("AuthList", auths);
        Commons.Storages("set", "authorization", {
          authorization: true,
          authDate: Commons.DateFormating(new Date()),
        });
        navigate("/Home");
      });
    } catch (e) {
      console.log(e);
      if (e.response.data === "wrong token") {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "중복 로그인입니다.",
        });
        return false;
      }
      setSnackbars({
        toggle: true,
        type: "error",
        message: "아이디 혹은 비밀번호를 확인하세요.",
      });
    } finally {
      if (screenWidth < 400) {
        setProgressbar(false);
      } else {
        Dialog.ProgressBar(false);
      }
    }
  };

  return (
    <>
      <LoginScreen
        inputs={inputs}
        setInputs={setInputs}
        combos={combos}
        LoginLogic={LoginLogic}
      />
      <Progressbar value={progress} />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default Login;
